import { render, staticRenderFns } from "./Setbank.vue?vue&type=template&id=b4a7d082&scoped=true&"
import script from "./Setbank.vue?vue&type=script&lang=js&"
export * from "./Setbank.vue?vue&type=script&lang=js&"
import style0 from "./Setbank.vue?vue&type=style&index=0&id=b4a7d082&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a7d082",
  null
  
)

export default component.exports